<template>
  <CardSection :error="majorError" :loading="isSavableStateLoading">
    <template #header>
      Create New CSV Upload Batch
    </template>
    <template #body>
      <fieldset>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <SingleSelect
              :key="formKey"
              v-model="formData.transplant_center_id"
              name="tc_code"
              label="Transplant Center"
              :options="teamStore.allTransplantCenters"
              label-key="code"
              value-key="id"
              :filter="true"
              :show-clear="true"
              rules="required"
              col-style="form-group-standard-column"
              required
            />
            
            <div class="form-group-standard-column">
              <label for="batch_date">Batch Date</label>
              <VueDatePicker
                model-type="yyyy-MM-dd"
                :enable-time-picker="false"
                name="batch_date" 
                v-model="formData.batch_date"
                :auto-apply="true"
              />
              <small class="form-text text-muted">Select the batch processing date corresponding to the uploaded zip file.</small>  
            </div>
          </div>

          <ActionToolbar
            primary-button-text="Create Batch"
            secondary-button-text="Cancel"
            primary-type="submit"
            primary-style="success"
            :component-state="currentState"
            :success-message="successMessage" 
            :error-message="formError"
            @secondary-click="cancel"
          />
        </form>
      </fieldset>
    </template>
  </CardSection>
</template>

<script lang="ts">
import { ref } from 'vue';
import { EP } from '@/src/endpoints'
import beApiClient from '@/src/be-api-client'
import CardSection from "@/src/components/shared/CardSection.vue";
import SingleSelect from "@/src/components/shared/FormComponents/SingleSelect.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useTeamStore } from '@/src/stores/team';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { handleErrors } from '@/src/utils.js';
import { VueDatePicker } from '@vuepic/vue-datepicker';

export default {
  name: 'FinalizedOfferCSVBatchesNew',
  mixins: [savableStateMixin],
  components: {
    CardSection,
    SingleSelect,
    VueDatePicker,
    ActionToolbar
  },
  data() {
    const teamStore = useTeamStore();
    const formKey = ref(0);
    const formData = ref({
      transplant_center_id: '',
      batch_date: new Date().toISOString().split('T')[0]
    });
    const successMessage = ref('');
    const errorMessage = ref('');
    const uploadedBatch = ref(null)
   
    return {
      formData,
      successMessage,
      errorMessage,
      uploadedBatch,
      teamStore,
      formKey
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      await this.teamStore.loadAllTransplantCentres();
      this.setSavableStateIdle();
    } catch (error) {
      this.handleMajorError(error);
    }
  },
  methods: {
     async handleSubmit() {
      this.setSavableStateProcessing();
      try {
        const response = await beApiClient.post(EP.admin.finalized_offers_csv_batches.create, {
          transplant_center_id: this.formData.transplant_center_id,
          batch_date: this.formData.batch_date
        })

        // Success response
        this.uploadedBatch = response.data;
        this.successMessage = 'Successfully created new batch!';
        this.$router.push({ name: 'admin_unos_finalized_offers_csv_batch_show', params: { id: response.data.id } })
      } catch (error) {
        this.handleFormError(error.response ? handleErrors(error) : error); // Check the type of error we got, axios or something else
      }
    },
    cancel() {
      this.$router.push({ name: 'admin_unos_finalized_offers_csv_batch' });
    }
  },
}
</script>
